import * as React from 'react'
import { Modal } from '@amzn/dvui/dist/Modal'
import { acknowledgeEvent } from './utils'
import * as st from './ModalTrigger.module.scss'

type RenderProp = (args: ModalRenderPropArgs) => React.ReactChild

export type CloseModal = () => void
export type OpenModal = () => void
export type OpenModalClickHandler = (e: React.MouseEvent<HTMLElement>) => void

export interface ToggleRenderPropArgs {
  openModal: OpenModal
  openModalClickHandler: OpenModalClickHandler
  closeModal: CloseModal
}

export interface ModalRenderPropArgs {
  closeModal: CloseModal
}

interface ModalTriggerProps {
  isOpen?: boolean
  toggle?: (args: ToggleRenderPropArgs) => React.ReactChild
  modalContent: React.ReactChild | RenderProp
  modalFooter?: React.ReactChild | RenderProp
  modalHeader?: React.ReactChild | RenderProp
  modalId?: string
  onClose?: () => void
  className?: string,
  size?:  "xs" | "s" | "m" | "l"
}

interface State {
  isVisible: boolean
}
export class ModalTrigger extends React.Component<ModalTriggerProps, State> {
  state = {
    isVisible: Boolean(this.props.isOpen),
  }

  componentDidUpdate(prevProps: ModalTriggerProps) {
    const { isOpen } = this.props
    if (isOpen !== prevProps.isOpen) {
      this.setState({ isVisible: isOpen })
    }
  }

  openModal = (): void => {
    this.setState({ isVisible: true })
  }

  openModalClickHandler = (e: React.MouseEvent<HTMLElement>): void => {
    acknowledgeEvent(e)
    this.openModal()
    e.preventDefault()
  }

  closeModal = (): void => {
    this.setState({ isVisible: false })
    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  render() {
    const closeModal = this.closeModal

    const toggleRenderPropArgs = {
      openModal: this.openModal,
      openModalClickHandler: this.openModalClickHandler,
      closeModal,
    }

    const modalRenderPropArgs = {
      closeModal,
    }

    const { modalContent, modalHeader, modalFooter, toggle, modalId, className, size } = this.props

    const footer =
      typeof modalFooter === 'function'
        ? modalFooter(modalRenderPropArgs)
        : modalFooter
    const header =
      typeof modalHeader === 'function'
        ? modalHeader(modalRenderPropArgs)
        : modalHeader
    const content =
      typeof modalContent === 'function'
        ? modalContent(modalRenderPropArgs)
        : modalContent

    return (
      <>
        {this.state.isVisible && (
          <Modal
            className={className || 'av-narrow'}
            isVisible={true}
            onClose={closeModal}
            footer={<div className={st.modalFooter}>{footer}</div>}
            header={<h3>{header}</h3>}
            modalId={modalId}
            size={size}>
            {content}
          </Modal>
        )}
        {toggle && toggle(toggleRenderPropArgs)}
      </>
    )
  }
}
